var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',{attrs:{"title":"Crear nuevo pack de eventos"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v("Datos del pack")])]},proxy:true},{key:"content",fn:function(){return [_c('Form',{attrs:{"data":_vm.data},on:{"terminado":function($event){return _vm.crearPack()}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }